// extracted by mini-css-extract-plugin
export default {"separator":"separator_z1RGUqKg","separator__isheader":"separator__isheader_B3OM3Tcw","separator__isbanner":"separator__isbanner_hgGVltJs"};